import { valoradorBandEstimates } from '../valoradorListing';
import { valoradorFinancialEstimates } from '../valoradorFinancialBands';
import { resolveFinancialProfile, financialProfileOptions } from './profiles';
import { calculateValuation } from './calculate';
import methodology from './methodology.json';

/** Convert private selected bands into the existing methodology without changing public data. */
export const estimateValorador = (answers, year = new Date().getFullYear()) => {
  const profile = resolveFinancialProfile(answers);
  const base = valoradorBandEstimates(answers, year);
  const money = valoradorFinancialEstimates(answers);
  const input = {
    ...answers,
    turnover: base.facturacion,
    age: base.anio == null ? null : year - base.anio,
    team: base.emp,
    ...Object.fromEntries(Object.entries(money).map(([key, row]) => [key, row.value])),
    rent: ['si', 'none'].includes(answers.rentPaid)
      ? 0
      : answers.rentPaid === 'no'
      ? money.rent.value
      : null,
    property:
      answers.propertyIncluded === 'no'
        ? 0
        : answers.propertyIncluded === 'si'
        ? money.property.value
        : null,
    stock: !profile?.stock || money.stock.status === 'notApplicable' ? 0 : money.stock.value,
  };
  const quality = [
    ['g12', methodology.growth],
    ['g24', methodology.growth],
  ];
  if (profile?.vis === 'recurrencia') {
    quality.push(['rec', methodology.recurrence]);
    if (answers.rec && answers.rec !== 'r1') quality.push(['model', methodology.model]);
  }
  if (profile?.vis === 'backlog') quality.push(['backlog', methodology.backlog]);
  if (profile?.conc) quality.push(['concentration', methodology.concentration]);
  const uncertainFactors = quality
    .filter(
      ([key, rows]) => answers[key] !== 'notApplicable' && !rows.some(row => row.v === answers[key])
    )
    .map(([key]) => key);
  const result = calculateValuation(input, profile);
  return {
    ...result,
    status: result?.status || (!profile ? 'unsupported' : 'incomplete'),
    profile,
    needsProfile:
      !profile &&
      financialProfileOptions(answers.sector).length > 1 &&
      answers.financialProfile !== 'notCovered',
    input,
    missingNormalization:
      result?.missingNormalization ||
      [
        ['facturacion', base.facturacion],
        ['empleados', base.empleados],
        ['antiguedad', base.antiguedad],
      ]
        .filter(([, value]) => value == null)
        .map(([key]) => key),
    uncertainFactors,
  };
};
